import { Image, View } from 'react-native'

// Android 12 receives a 288dp transparent icon viewport. The generated mark
// deliberately occupies its central 144dp safe area, so it survives the
// system mask without growing a coloured square behind it. Render that same
// viewport during the JS handoff: the visible mark keeps the exact native
// scale while the transparent padding disappears into the shared light surface.
const SOURCE_VIEWPORT_SIZE = 288
const VISIBLE_MARK_RATIO = 144 / 288
const MARK_SIZE = Math.round(SOURCE_VIEWPORT_SIZE * VISIBLE_MARK_RATIO)
const IMAGE_INSET = Math.round((SOURCE_VIEWPORT_SIZE - MARK_SIZE) / 2)

export function StartupMark({ size = MARK_SIZE }: { size?: number }) {
  const sourceSize = Math.round(size / VISIBLE_MARK_RATIO)

  return (
    <View
      accessible
      accessibilityRole="image"
      accessibilityLabel="Tago"
      style={{
        width: sourceSize,
        height: sourceSize,
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Image
        source={require('../../assets/images/splash-android12-icon.png')}
        style={{
          width: sourceSize,
          height: sourceSize,
        }}
        resizeMode="contain"
        accessibilityIgnoresInvertColors
      />
    </View>
  )
}

/** Shared size makes the native → JS visual contract explicit in tests. */
export const STARTUP_MARK_SIZE = MARK_SIZE
export const STARTUP_MARK_SOURCE_VIEWPORT_SIZE = SOURCE_VIEWPORT_SIZE
export const STARTUP_MARK_IMAGE_INSET = IMAGE_INSET
